export default __webpack_public_path__ + "static/media/Inter-Bold.9aab1ebe.ttf";